import React, { useEffect, useState } from 'react';
import { GoogleMap, LoadScript, DirectionsService, DirectionsRenderer, Marker, InfoWindow } from '@react-google-maps/api';

const mapContainerStyle = {
  height: "500px",
  width: "100%"
};

const center = {
  lat: 37.7749,
  lng: -122.4194
};

const MultipleMapComponent = ({ routes }) => {
  
  const [directions, setDirections] = useState([]);
  const [directionsRequests, setDirectionsRequests] = useState([]);
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState(null); // State to track selected marker
  const [placeDetails, setPlaceDetails] = useState(null); // State to store place details

  useEffect(() => {
    // Throttle the directions requests
    const interval = setInterval(() => {
      if (directionsRequests.length > 0) {
        const { route, index } = directionsRequests.shift();
        fetchDirections(route, index);
      }
    }, 1000); // Adjust the interval as needed

    return () => clearInterval(interval);
  }, [directionsRequests]);

  const fetchDirections = (route, index) => {
    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin: route.origin,
        destination: route.destination,
        waypoints: route.waypoints,
        travelMode: 'DRIVING'
      },
      (result, status) => {
        if (status === 'OK') {
          setDirections(prev => {
            const newDirections = [...prev];
            newDirections[index] = result;
            return newDirections;
          });
        } else {
          console.error(`Error fetching directions: ${result}`);
        }
      }
    );
  };

  useEffect(() => {
    // Ensure routes is defined before mapping
    if (routes && Array.isArray(routes)) {
      const requests = routes.map((route, index) => ({ route, index }));
      setDirectionsRequests(requests);
    } else {
      console.error("Routes is undefined or not an array");
    }
  }, [routes]);

  const handleMarkerClick = async (type, location, time,driverDetails,passengerDetails,vehicleDetails) => {
    try {
      const geocoder = new window.google.maps.Geocoder();
      const response = await geocoder.geocode({ location });
      const placeName = response.results[0]?.formatted_address || "Unknown Place";

      // Convert time to 12-hour format with AM/PM
      const formattedTime = new Date(`1970-01-01T${time}`).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });

      setSelectedMarker({ type, location });
      setPlaceDetails({ placeName,time: formattedTime, driverDetails, passengerDetails, vehicleDetails });
    } catch (error) {
      console.error("Error fetching place details:", error);
      setPlaceDetails({ placeName: "Unknown Place", time: "Unknown Time" });
    }
  };

  const handleClosePopup = () => {
    setSelectedMarker(null);
    setPlaceDetails(null);
  };

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI"
      onLoad={() => setIsApiLoaded(true)}
    >
      {isApiLoaded && (
        <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={7}>
          {routes && routes.length > 0 ? (
            routes.map((route, index) => {
              const markerColor = `hsl(${(index * 60) % 360}, 100%, 50%)`;
              const markerLine = `hsl(${(index * 60) % 360}, 100%, 50%)`;
              return (
                <React.Fragment key={index}>
                  <Marker
                    position={route.origin}
                    label="A"
                    icon={{
                      path: window.google.maps.SymbolPath.CIRCLE,
                      scale: 10,
                      fillColor: markerColor,
                      fillOpacity: 1,
                      strokeWeight: 1,
                      strokeColor: "#000",
                    }}
                    onClick={() => handleMarkerClick(
                      "Pickup",
                       route.origin,
                        route.pickup_time,
                        route.driverDetails,
                        route.passengerDetails,
                        route.vehicleDetails
                      )} // Handle click for pickup
                  />
                  <Marker
                    position={route.destination}
                    label="B"
                    icon={{
                      path: window.google.maps.SymbolPath.CIRCLE,
                      scale: 10,
                      fillColor: markerColor,
                      fillOpacity: 1,
                      strokeWeight: 1,
                      strokeColor: "#000",
                    }}
                    onClick={() => handleMarkerClick(
                      "Drop-off", 
                      route.destination,
                       route.drop_off_time,
                       route.driverDetails,
                        route.passengerDetails,
                        route.vehicleDetails
                       )} // Handle click for drop-off
                  />
                  {directions[index] && (
                    <DirectionsRenderer
                      directions={directions[index]}
                      options={{
                        polylineOptions: {
                          strokeColor: markerLine, // Dark blue color
                          strokeOpacity: 1.0,
                          strokeWeight: 5,
                        },
                        suppressMarkers: true, // Suppress default markers
                      }}
                    />
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <></>
          )}

          {/* InfoWindow for selected marker */}
          {selectedMarker && placeDetails && (
            <InfoWindow
              position={selectedMarker.location}
              onCloseClick={handleClosePopup}
            >
              <>
                <h4>{selectedMarker.type} Location</h4>
                <p><strong style={{fontSize:'15px'}}>Place : </strong> {placeDetails.placeName}</p>
                <p><strong style={{fontSize:'15px'}}>Driver : 
                  </strong> { placeDetails.driverDetails.firstName && placeDetails.driverDetails.lastName ? 
                    `${placeDetails.driverDetails.firstName} ${placeDetails.driverDetails.middleName} ${placeDetails.driverDetails.lastName}` : 
                    placeDetails.driverDetails.fullName || 'N/A' }</p>
                <p><strong style={{fontSize:'15px'}}>Passenger : 
                  </strong> {`${placeDetails.passengerDetails.firstName} ${placeDetails.passengerDetails?.middleName} ${placeDetails.passengerDetails.lastName}`}</p>
                <p><strong style={{fontSize:'15px'}}>Vehicle : 
                  </strong> {`${placeDetails.vehicleDetails?.vehicle_name}`}</p>
                <p><strong style={{fontSize:'15px'}}>Time : </strong> {placeDetails.time}</p>
              </>
            </InfoWindow>
          )}
        </GoogleMap>
      )}
    </LoadScript>
  );
};

export default MultipleMapComponent;